/** 11sight aded packages BEGIN */
import { IconArrowDown } from 'jitsi/base/icons/svg';
/** 11sight aded packages END */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'jitsi/base/i18n/functions';
// import { IconArrowUp } from 'jitsi/base/icons/svg';
import JitsiMeetJS from 'jitsi/base/lib-jitsi-meet/_.web';
import { IGUMPendingState } from 'jitsi/base/media/types';
import ToolboxButtonWithIcon from 'jitsi/base/toolbox/components/web/ToolboxButtonWithIcon';
import { toggleAudioSettings } from 'jitsi/settings/actions.web';
import AudioSettingsPopup from 'jitsi/settings/components/web/audio/AudioSettingsPopup';
import { getAudioSettingsVisibility } from 'jitsi/settings/functions.web';
import { isAudioSettingsButtonDisabled } from 'jitsi/toolbox/functions.web';
import AudioMuteButton from 'jitsi/toolbox/components/web/AudioMuteButton';
/**
 * Button used for audio & audio settings.
 *
 * @returns {ReactElement}
 */
class AudioSettingsButton extends Component {
    /**
     * Initializes a new {@code AudioSettingsButton} instance.
     *
     * @inheritdoc
     */
    constructor(props) {
        super(props);
        this._onEscClick = this._onEscClick.bind(this);
        this._onClick = this._onClick.bind(this);
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {KeyboardEvent} event - Esc key click to close the popup.
     * @returns {void}
     */
    _onEscClick(event) {
        if (event.key === 'Escape' && this.props.isOpen) {
            event.preventDefault();
            event.stopPropagation();
            this._onClick();
        }
    }
    /**
     * Click handler for the more actions entries.
     *
     * @param {MouseEvent} e - Mouse event.
     * @returns {void}
     */
    _onClick(e) {
        const { onAudioOptionsClick, isOpen } = this.props;
        if (isOpen) {
            e?.stopPropagation();
        }
        onAudioOptionsClick();
    }
    /**
     * Implements React's {@link Component#render}.
     *
     * @inheritdoc
     */
    render() {
        const { gumPending, hasPermissions, isDisabled, visible, isOpen, buttonKey, notifyMode, t } = this.props;
        const settingsDisabled = !hasPermissions || isDisabled || !JitsiMeetJS.mediaDevices.isMultipleAudioInputSupported();
        return visible ? (React.createElement(AudioSettingsPopup, null,
            React.createElement(ToolboxButtonWithIcon, { ariaControls: 'audio-settings-dialog', ariaExpanded: isOpen, ariaHasPopup: true, ariaLabel: t('toolbar.audioSettings'), buttonKey: buttonKey, 
                // 11sight line modified
                icon: IconArrowDown, iconDisabled: settingsDisabled || gumPending !== IGUMPendingState.NONE, iconId: 'audio-settings-button', iconTooltip: t('toolbar.audioSettings'), notifyMode: notifyMode, onIconClick: this._onClick, onIconKeyDown: this._onEscClick },
                React.createElement(AudioMuteButton, { colorInClass: true, buttonKey: buttonKey, notifyMode: notifyMode })))) : (React.createElement(AudioMuteButton, { buttonKey: buttonKey, notifyMode: notifyMode }));
    }
}
/**
 * Function that maps parts of Redux state tree into component props.
 *
 * @param {Object} state - Redux state.
 * @returns {Object}
 */
function mapStateToProps(state) {
    const { permissions = { audio: false } } = state['features/base/devices'];
    const { gumPending } = state['features/base/media'].audio;
    return {
        gumPending,
        hasPermissions: permissions.audio,
        isDisabled: Boolean(isAudioSettingsButtonDisabled(state)),
        isOpen: Boolean(getAudioSettingsVisibility(state)),
        visible: true,
    };
}
const mapDispatchToProps = {
    onAudioOptionsClick: toggleAudioSettings,
};
export default translate(connect(mapStateToProps, mapDispatchToProps)(AudioSettingsButton));
